module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_sola@2x-303cdb6b4b7bbcafdf13305db75da030.webp";